import React, { useEffect, useState } from 'react';
import { useTour } from '../contexts/TourContext';
import { useLocation } from 'react-router-dom';
import { debugLog } from '../utils/debugLogger';
import './TourToast.css';

const routeToTourKeyMap: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/applications': 'applications',
  '/resumes': 'resumes',
  '/profile': 'profile',
  '/settings': 'settings',
  '/job-search': 'jobSearch',
  '/agents': 'agents',
};

export const TourToast: React.FC = () => {
  const location = useLocation();
  const { startTour, isTourCompleted, markTourDismissed } = useTour();
  const [showToast, setShowToast] = useState(false);
  const [currentTourKey, setCurrentTourKey] = useState<string | null>(null);

  useEffect(() => {
    const tourKey = routeToTourKeyMap[location.pathname];
    
    if (!tourKey) {
      setShowToast(false);
      return;
    }

    // Check if tour for this route hasn't been completed
    if (!isTourCompleted(tourKey)) {
      setCurrentTourKey(tourKey);
      // Show toast after a brief delay to let page load
      const timer = setTimeout(() => {
        setShowToast(true);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setShowToast(false);
    }
  }, [location.pathname, isTourCompleted]);

  const handleStartTour = () => {
    if (currentTourKey) {
      console.log('[TourToast] Starting tour for:', currentTourKey);
      // #region agent log
      debugLog({location:'TourToast.tsx:handleStartTour',message:'Toast button clicked',data:{currentTourKey},hypothesisId:'A'});
      // #endregion
      
      setShowToast(false);
      // Add small delay to ensure toast dismissal completes and DOM is ready
      setTimeout(() => {
        startTour(currentTourKey);
      }, 100);
    } else {
      console.error('[TourToast] No currentTourKey available');
    }
  };

  const handleDismiss = () => {
    if (currentTourKey) {
      markTourDismissed(currentTourKey);
    }
    setShowToast(false);
  };

  if (!showToast || !currentTourKey) {
    return null;
  }

  return (
    <div className="tour-toast">
      <div className="tour-toast-content">
        <div className="tour-toast-icon">?</div>
        <div className="tour-toast-text">
          <div className="tour-toast-title">New here?</div>
          <div className="tour-toast-message">Take a quick tour to learn about this page</div>
        </div>
      </div>
      <div className="tour-toast-actions">
        <button className="tour-toast-button tour-toast-button-primary" onClick={handleStartTour}>
          Start Tour
        </button>
        <button className="tour-toast-button tour-toast-button-secondary" onClick={handleDismiss}>
          Skip
        </button>
      </div>
    </div>
  );
};
